'use client'

import React, { useEffect, useRef } from 'react'
import { registerFrame, unregisterFrame } from '@/lib/analytics/landingPageDwell'
import { observeFrame, unobserveFrame } from './dwellObserver'

interface DwellFrameProps {
    /** Stable section id (e.g. `how_it_works`). */
    frameId: string
    /** Sort order for warehouse rollups. */
    frameIndex: number
    className?: string
    children: React.ReactNode
}

/** Wraps a landing-page section in a <div> the IntersectionObserver watches. */
export default function DwellFrame({ frameId, frameIndex, className, children }: DwellFrameProps) {
    const ref = useRef<HTMLDivElement | null>(null)

    useEffect(() => {
        const el = ref.current
        if (!el) return
        registerFrame({ frameId, frameIndex })
        observeFrame(el, { frameId, frameIndex })
        return () => {
            unobserveFrame(el)
            unregisterFrame(frameId)
        }
    }, [frameId, frameIndex])

    return (
        <div ref={ref} data-dwell-frame={frameId} className={className}>
            {children}
        </div>
    )
}
